import { datadogRum } from "@datadog/browser-rum";
import base64url from "base64url";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  getDataFromSessionStorage,
  setDataInSessionStorage,
} from "utils/helper";

import {
  Container,
  Box,
  Button,
} from "@/components/onboardingSections/container";
import { CustomOtpInput } from "@/components/onboardingSections/inputs";
import styles from "@/styles/onboarding.module.scss";

export default function Verify({ mobileNumber, verifyComplete }) {
  const router = useRouter();

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [otp, setOtp] = useState(null);
  const [otpError, setOtpError] = useState(false);
  const [loading, setLoading] = useState(false);

  const getTextCode = () => {
    if (window.OTPCredential) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then(otp => {
          setOtp(otp.code);
          ac.abort();
        })
        .catch(err => {
          ac.abort();
          console.log(err);
        });
    }
  };

  useEffect(() => {
    getTextCode();
  }, []);

  useEffect(() => {
    if (otp?.length === 4) {
      if (otpError) {
        setButtonDisabled(true);
      } else {
        setButtonDisabled(false);
      }
    } else {
      setButtonDisabled(true);
      setOtpError(false);
    }
  }, [otp, otpError]);

  const resendOtp = async () => {
    setLoading(true);
    const body = {
      onmouuid: getDataFromSessionStorage("applicationTokens").uuid,
      phonenumber: "+44" + mobileNumber,
    };
    const response = await fetch("/api/onboarding/resend-otp", {
      method: "POST",
      headers: {
        Authorization: `${
          getDataFromSessionStorage("applicationTokens").onmoAT
        }`,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      getTextCode();
      setLoading(false);
    } else {
      router.push("/500");
      console.log("failed to resend otp");
    }
  };

  const verifyOtp = async e => {
    e.preventDefault();
    setLoading(true);
    datadogRum.addAction("2.3-OTP-Success", { onboardingChannel: "Organic" });
    const body = {
      onmouuid: getDataFromSessionStorage("applicationTokens").uuid,
      otp: otp,
    };
    const response = await fetch("/api/onboarding/verify-otp", {
      method: "POST",
      headers: {
        Authorization: `${
          getDataFromSessionStorage("applicationTokens").onmoAT
        }`,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      datadogRum.addAction("2.4-OTP-Submitted", {
        onboardingChannel: "Organic",
      });
      const tokens = getDataFromSessionStorage("applicationTokens");
      const newToken = { ...tokens, ph: base64url("+44" + mobileNumber) };
      setDataInSessionStorage("applicationTokens", newToken);
      verifyComplete(true);
    } else {
      setButtonDisabled(true);
      setOtpError(true);
      setLoading(false);
    }
  };

  return (
    <Container onSubmit={verifyOtp}>
      <div className="text-center">
        <p className={styles.topTitle}>
          We&apos;ve sent a verification code to
        </p>
        <p className={styles.topTitle}>
          <NumberFormat
            value={mobileNumber}
            format="+44 (0) #### ### ###"
            allowEmptyFormatting
            displayType="text"
          />
          . Please confirm it below.
        </p>
      </div>

      <Box gap={16}>
        <CustomOtpInput
          old
          otp={otp}
          otpError={otpError}
          setOtp={e => setOtp(e)}
        />
        <div className="flex flex-col gap-7">
          <button
            type="button"
            disabled={loading}
            onClick={resendOtp}
            className={styles.oldOtpResend}
          >
            Resend verification code
          </button>
          <div className="hidden md:block">
            <Button disabled={buttonDisabled} loading={loading}>
              Submit
            </Button>
          </div>
        </div>
      </Box>
      <div className="block md:hidden">
        <Button disabled={buttonDisabled} loading={loading}>
          Submit
        </Button>
      </div>
    </Container>
  );
}
